import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Button, IconButton, Skeleton, Stack, Tooltip, Typography } from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContainerArbitrator } from '../../ArbitrationObjects/ContainerArbitrator/containerArbitrator';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
import { getImageUrl } from '../../data/aws/s3/UserBlobs';
export const UserButton = ({ isAuthenticated, user }) => {
    const [{ isSmallView }] = useContext(AppMainViewContext);
    const navigate = useNavigate();
    const toUserPage = useCallback(() => {
        if (!user)
            return;
        const link = ContainerArbitrator.getCanonicalContainerLinkForObject({ vob: user });
        navigate(link);
    }, [user]);
    const [avatarURL, setAvatarURL] = useState('');
    useEffect(() => {
        async function effectUrl() {
            const objectOrString = (await getImageUrl(user, true)) ?? (await getImageUrl(user, false));
            if (typeof objectOrString === 'string') {
                const url = objectOrString;
                setAvatarURL(url);
            }
            else {
                setAvatarURL('');
            }
        }
        effectUrl();
    }, [user?.sk, user?.primaryS3Image?.key]);
    if (!isAuthenticated)
        return null;
    const avatarButton = user ? (_jsx(Tooltip, { title: 'View account', placement: "bottom", arrow: true, children: _jsx(IconButton, { color: "inherit", onClick: () => toUserPage(), sx: { padding: 0 }, children: _jsx(Avatar, { src: avatarURL, sx: { width: 32, height: 32 } }) }) })) : (_jsx(Skeleton, { variant: "circular", width: 32, height: 32, sx: { marginInline: 1, backgroundColor: (t) => t.palette.primary.light } }));
    const userButton = user ? (_jsx(Tooltip, { title: 'View account', placement: "bottom", arrow: true, children: _jsx(Button, { color: "inherit", endIcon: _jsx(Avatar, { src: avatarURL, sx: { width: 32, height: 32 } }), onClick: () => toUserPage(), sx: { paddingBlock: 0.5, ['&:hover']: { backgroundColor: (t) => t.palette.primary.dark } }, children: _jsx(Typography, { children: user?.name }) }) })) : (_jsxs(Stack, { direction: 'row', alignItems: 'center', gap: 1, marginInline: 1, children: [_jsx(Skeleton, { variant: "text", width: 100, height: 32, sx: { backgroundColor: (t) => t.palette.primary.light } }), _jsx(Skeleton, { variant: "circular", width: 32, height: 32, sx: { backgroundColor: (t) => t.palette.primary.light } })] }));
    return isSmallView ? avatarButton : userButton;
};
